import React from "react";

import { Box, Grid, Link, Typography } from "@mui/material";

import { CUSTOMER_SUPPORT_EMAIL, SALES_EMAIL } from "helpers/constants";
import { colors } from "theme";

interface LocationInfo {
  title: string;
  info: string;
  infoLink: string;
}

enum InfoType {
  PHONE,
  EMAIL,
}

const EMAILS: LocationInfo[] = [
  {
    title: "Sales support",
    info: SALES_EMAIL,
    infoLink: `mailto:${SALES_EMAIL}`,
  },
  {
    title: "Customer support",
    info: CUSTOMER_SUPPORT_EMAIL,
    infoLink: `mailto:${CUSTOMER_SUPPORT_EMAIL}`,
  },
];

const PHONES: LocationInfo[] = [
  {
    title: "Line 1",
    info: "+1 (877) 771-1093",
    infoLink: "tel:+1.877.771.1093",
  },
  {
    title: "Line 2",
    info: "+1 (303) 357-9001",
    infoLink: "tel:+1.303.357.9001",
  },
  {
    title: "Fax",
    info: "+1 (303) 736-7150",
    infoLink: "tel:+1.303.736.7150",
  },
];

const LocationInfoItem: React.FC<LocationInfo & { infoType: InfoType }> = ({
  title,
  info,
  infoLink,
  infoType,
}) => (
  <Box className="location-info-item">
    <Typography variant="h6" component="h4">
      {title}
    </Typography>
    <Box p={1} pl={0} pb="7px" borderBottom={`1px solid ${colors.grey[600]}`}>
      <Link
        href={infoLink}
        target={infoType === InfoType.EMAIL ? "_blank" : "_self"}
        color="secondary"
      >
        {info}
      </Link>
    </Box>
  </Box>
);

const LocationInfoList: React.FC<{
  infos: LocationInfo[];
  infoType: InfoType;
}> = ({ infos, infoType }) => (
  <Box display="flex" flexDirection="column">
    <Typography variant="h5" component="h3">
      {infoType === InfoType.EMAIL ? "Email" : "Phone"}
    </Typography>
    <Box mt={2} component="ul" gap="16px" display="flex" flexDirection="column">
      {infos.map((locationInfo) => (
        <Box key={locationInfo.infoLink} component="li">
          <LocationInfoItem {...locationInfo} infoType={infoType} />
        </Box>
      ))}
    </Box>
  </Box>
);

export const OurLocations = () => (
  <Grid
    container
    spacing={3}
    justifyContent="center"
    component="ul"
    className="location-infos"
  >
    <Grid item xs={12} sm={4} component="li" spacing={3}>
      <Box display="flex" flexDirection="column">
        <Typography variant="h5" component="h3">
          Address
        </Typography>
        <Box mt={2}>
          <Typography component="address" style={{ fontStyle: "normal" }}>
            2477 55th Street, Suite 202
            <br /> Boulder, CO 80301
            <br /> USA
            <br />
            <Link
              href="https://www.google.com/maps/place/2477+55th+St,+Boulder,+CO+80301/@40.0235329,-105.2290834,17z/data=!3m1!4b1!4m5!3m4!1s0x876bedfc6d1aa919:0xf95b7208122c8af!8m2!3d40.0235329!4d-105.2268947"
              target="_blank"
              color="secondary"
            >
              Google Map It!
            </Link>
          </Typography>
        </Box>
      </Box>
    </Grid>
    <Grid item xs={12} sm={4} component="li">
      <LocationInfoList infoType={InfoType.PHONE} infos={PHONES} />
    </Grid>
    <Grid item xs={12} sm={4} component="li">
      <LocationInfoList infoType={InfoType.EMAIL} infos={EMAILS} />
    </Grid>
  </Grid>
);
